// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"menu-module--wrapper--TMFax","list":"menu-module--list--aKDGP","item":"menu-module--item--1Xh-J","button":"menu-module--button--1_tG0","link":"menu-module--link--2jDds"};